import React, { Component } from 'react'
import Keen from 'keen-js'
import { object, string } from 'prop-types'

// utils
import { createQuery, runQuery, createQueryCTA } from '../../../utils/KeenReport'

// components
import Spinner from '../../Spinner'
import CompleteFunnelGraph from '../CompleteFunnelGraph'

class RegularFunnel extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      hasError: false,
      recommendations: 0,
      plays: 0,
      videoPlays: 0,
      conversions: 0,
      hasVideoPlay: false
    }

    this.runKeen = this.runKeen.bind(this)
    this.toggleVideoPlay = this.toggleVideoPlay.bind(this)
    this.prepareDataToGraph = this.prepareDataToGraph.bind(this)
  }
  componentDidMount () {
    this.runKeen(this.props)
  }
  componentWillReceiveProps (nextProps) {
    this.runKeen(nextProps)
  }
  toggleVideoPlay (hasVideoPlay) {
    this.setState({
      hasVideoPlay
    }, () => {
      this.prepareDataToGraph()
    })
  }
  prepareDataToGraph () {
    // let { videoPlays, hasVideoPlay } = this.state
    let { recommendations, plays, conversions } = this.state
    let dataForGraph = [
      { label: 'Recomendações', value: recommendations, type: 'line', rate: 1 },
      { label: 'Plays', value: plays, type: 'line', rate: (plays / recommendations) },
    ]

    // if (hasVideoPlay) {
    //   dataForGraph.push({ label: 'Player tocar video', value: videoPlays, type: 'line', color: '#ad48a1', rate: (videoPlays / plays) })
    //   dataForGraph.push({ label: 'Conversão', value: conversions, type: 'line', color: '#2CA02C', rate: (conversions / videoPlays) })
    // } else {
      dataForGraph.push({ label: 'Conversão', value: conversions, type: 'line', color: '#2CA02C', rate: (conversions / plays) })
    // }

    this.setState({
      isLoading: false,
      hasError: false,
      dataForGraph
    })
  }
  runKeen (props) {
    Keen.ready(() => {
      const { campaign, actor, timeframe, video, filters } = props
      let queries

      this.setState({
        isLoading: true,
        hasError: false
      })

      if (actor === 'pessoas') {
        queries = [
          createQuery('count_unique', 'video_recomended', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQuery('count_unique', 'video_unique_click', timeframe, campaign, video, 'client_viewer_id', null, filters),
        ]
        if (video && video.conversion_filter) {
          queries.push(createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...video.conversion_filter, ...filters]))
        } else {
          if (campaign && campaign.conversion_filter) {
            queries.push(createQuery('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...campaign.conversion_filter, ...filters]))
          } else {
            queries.push(createQuery('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, filters))
          }
        }
      } else {
        queries = [
          createQuery('count', 'video_recomended', timeframe, campaign, video, null, null, filters),
          createQuery('count', 'video_unique_click', timeframe, campaign, video, null, null, filters),
        ]
        if (video && video.conversion_filter) {
          queries.push(createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.conversion_filter, ...filters]))
        } else {
          if (campaign && campaign.conversion_filter) {
            queries.push(createQuery('count', 'user_interacted', timeframe, campaign, video, null, null, [...campaign.conversion_filter, ...filters]))
          } else {
            queries.push(createQuery('count', 'user_interacted', timeframe, campaign, video, null, null, filters))
          }
        }
      }
      runQuery(queries)
        .then((res) => {
          let recommendations = res[0].result
          let plays = res[1].result
          // let videoPlays = res[2].result
          let conversions = res[2].result

          this.setState({
            recommendations,
            plays,
            // videoPlays,
            conversions
          }, () => {
            this.prepareDataToGraph()
          })
        }, (err) => {
          console.log('Erro rodando a query do Keen.', err)
          this.setState({
            hasError: true
          })
        })
    })
  }
  render () {
    let { isLoading, hasError } = this.state
    return (
      <div>
        <div className={isLoading ? 'hidden' : ''}>
          <CompleteFunnelGraph
            dataForGraph={this.state.dataForGraph}
            toggleVideoPlay={this.toggleVideoPlay}
          />
        </div>
        <Spinner isLoading={isLoading} hasError={hasError} runKeen={() => { this.runKeen(this.props) }} />
      </div>
    )
  }
}

RegularFunnel.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
}

export default RegularFunnel



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/RegularFunnel.js